// import { useStore } from "effector-react"
import React, { useEffect } from "react"
import { NavLink } from "react-router-dom"

import "../styles/DemandSidebar.css";
import { urlDemandSubGroupServices } from "../../../common/config/vars";
import { $accounts, $selectedAccountIdx } from "../../../common/accounts2";
import { $contractorDems, queryContractorDems} from "../logics/contractorDemands";
import { useStore } from "effector-react";

interface ISidebarGroupList {
  setCurrItem: React.Dispatch<React.SetStateAction<string>>
}

export const SidebarGroupList = ({setCurrItem}: ISidebarGroupList) => {
  const selAccIdx = useStore($selectedAccountIdx)
  const {accounts} = useStore($accounts)


  const [openMenu, setOpenMenu] = React.useState(false);
  const buttonClassName = `${
    openMenu
      ? "dem-sidebar-button dem-sidebar-button_active"
      : "dem-sidebar-button"
  }`;
  function openCloseMenu() {
    setOpenMenu(!openMenu);
  }
  function closeByRedirect(itemText: string) {
    setOpenMenu(false);
    setCurrItem(`Категория "${itemText}"`)
  }
  const sidebarClassName = `${
    openMenu ? "dem-sidebar dem-sidebar-active" : "dem-sidebar"
  }`;

  const {loading, failMsg, groups, services} = useStore($contractorDems)
  useEffect(() => {
    const id = selAccIdx
    var comid = -1;
    if(id !== -1){
      if(id < accounts.length){
        if(accounts[selAccIdx].companyId!==undefined){
          queryContractorDems(accounts[selAccIdx].companyId.toString())
        }
        return
      }
    }

    //let acc = accounts[selAccId]
    //if(acc != undefined) comid = acc.companyId
   queryContractorDems(comid+"") //"28" //if(groups.length == 0)
  }, [selAccIdx])

  return (
    <>
      <ul style={{width: "100%"}}>
        <li>
          <div className="category">Категории</div>
          <ul>
            {loading ? "Загрузка данных": <></>}
            {failMsg !=  "" ? failMsg: <></>}
            {groups.map((g, i) => (
              <li key={i}>
                <NavLink exact to={urlDemandSubGroupServices+ "/" + g.id} className="category-item" onClick={() => closeByRedirect(g.name)}>{g.name}</NavLink>
            </li>
            ))}
          </ul>
        </li>
      </ul>
    </>
  )
}